import React, {useEffect, useRef, useState} from 'react';
import {deepCmp} from "../../../../../helpers/JsUtils";

export function updateItemConversion(prev, newItem){
  if(!prev || !newItem || prev.id !== newItem.id){
    return null;
  }
  if(newItem.url_ts !== prev.url_ts || newItem.conversion !== prev.item_data.conversion){
    const url = `/mindfiles/${prev.mindfile_id}/show/${prev.item_data_id}/${prev.url_show_hash}/thumbnail?ts=${newItem.url_ts}`
    return {...prev, url_ts: newItem.url_ts, updated_at: newItem.updated_at, item_data:{...prev.item_data, conversion: newItem.conversion}, thumbnail_url:url};
  }
  return null;
}

function getConversionIds(itemList, itemExtra){
  return [...new Set([...itemList, itemExtra].filter(item => !!item && !!item.item_data && item.item_data.conversion === false).map(item => item.id))].sort();
}

function ConversionPoller(props) {
  const { mindfileId, itemList, itemExtra, getMindfileItemsDetails, updateItems, conversionStatusCallback } = props;
  const [conversionItemIds, setConversionItemIds] = useState(getConversionIds(itemList, itemExtra));
  useEffect(() => {
      const newList = getConversionIds(itemList, itemExtra);
      if(!deepCmp(newList, conversionItemIds)){
        setConversionItemIds(newList);
      }
    },
    // eslint-disable-next-line
    [itemList, itemExtra]
  )

  const [recon, setRecon] = useState(0);
  const conversionTimeout = useRef(null);
  useEffect(() => {
      if(!conversionItemIds || conversionItemIds.length === 0){
        return;
      }
      if(conversionTimeout.current !== null){
        return;
      }
      let controller = new AbortController();
      const { signal } = controller;

      conversionTimeout.current = setTimeout(() => {
        getMindfileItemsDetails(mindfileId, conversionItemIds, (itemUpdates) => {
          if(updateItems){
            updateItems((prevItems) => {
              let changed = false;
              const newItems = [...prevItems];
              itemUpdates.forEach(newItem => {
                let i = prevItems.findIndex(item => !!item && item.id === newItem.id);
                if(i === -1){
                  return;
                }
                const prev = prevItems[i];
                const updated = updateItemConversion(prev, newItem);
                if(updated){
                  newItems[i] = updated;
                  changed = true;
                }
              })
              return changed ? newItems : null;
            })
          }
          if(conversionStatusCallback) {
            conversionStatusCallback(itemUpdates);
          }
        }, signal);
        conversionTimeout.current = null;
        controller = null;
        setRecon(recon + 1);
      }, 7500);

      return () => {
        if(controller !== null) {
          controller.abort();
        }
        if(conversionTimeout.current !== null){
          clearTimeout(conversionTimeout.current);
          conversionTimeout.current = null;
        }
      }
    },
    // eslint-disable-next-line
    [conversionItemIds, recon]
  )

  return (
    <>
    </>
  );
}

export default ConversionPoller;
